var _jsxFileName = "/media/data/Sandbox/soapbox-defake/app/soapbox/features/compose/components/upload.tsx";
import "core-js/modules/web.dom-collections.iterator.js";
import classNames from 'clsx';
import { List as ImmutableList } from 'immutable';
import React, { useState } from 'react';
import { defineMessages, useIntl, FormattedMessage } from 'react-intl';
import { spring } from 'react-motion';
import { useHistory } from 'react-router-dom';
import { undoUploadCompose, changeUploadCompose, submitCompose } from 'soapbox/actions/compose';
import { openModal } from 'soapbox/actions/modals';
import Blurhash from 'soapbox/components/blurhash';
import Icon from 'soapbox/components/icon';
import IconButton from 'soapbox/components/icon-button';
import { useAppDispatch, useAppSelector, useCompose } from 'soapbox/hooks';
import Motion from '../../ui/util/optional-motion';

const bookIcon = require('@tabler/icons/book.svg');

const fileCodeIcon = require('@tabler/icons/file-code.svg');

const fileSpreadsheetIcon = require('@tabler/icons/file-spreadsheet.svg');

const fileTextIcon = require('@tabler/icons/file-text.svg');

const fileZipIcon = require('@tabler/icons/file-zip.svg');

const defaultIcon = require('@tabler/icons/paperclip.svg');

const presentationIcon = require('@tabler/icons/presentation.svg');

export const MIMETYPE_ICONS = {
  'application/x-freearc': fileZipIcon,
  'application/x-bzip': fileZipIcon,
  'application/x-bzip2': fileZipIcon,
  'application/gzip': fileZipIcon,
  'application/vnd.rar': fileZipIcon,
  'application/x-tar': fileZipIcon,
  'application/zip': fileZipIcon,
  'application/x-7z-compressed': fileZipIcon,
  'application/x-csh': fileCodeIcon,
  'application/html': fileCodeIcon,
  'text/javascript': fileCodeIcon,
  'application/json': fileCodeIcon,
  'application/ld+json': fileCodeIcon,
  'application/x-httpd-php': fileCodeIcon,
  'application/x-sh': fileCodeIcon,
  'application/xhtml+xml': fileCodeIcon,
  'application/xml': fileCodeIcon,
  'application/epub+zip': bookIcon,
  'application/vnd.oasis.opendocument.spreadsheet': fileSpreadsheetIcon,
  'application/vnd.ms-excel': fileSpreadsheetIcon,
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': fileSpreadsheetIcon,
  'application/pdf': fileTextIcon,
  'application/vnd.oasis.opendocument.presentation': presentationIcon,
  'application/vnd.ms-powerpoint': presentationIcon,
  'application/vnd.openxmlformats-officedocument.presentationml.presentation': presentationIcon,
  'text/plain': fileTextIcon,
  'application/rtf': fileTextIcon,
  'application/msword': fileTextIcon,
  'application/x-abiword': fileTextIcon,
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': fileTextIcon,
  'application/vnd.oasis.opendocument.text': fileTextIcon
};
const messages = defineMessages({
  description: {
    "id": "upload_form.description",
    "defaultMessage": "Describe for the visually impaired"
  },
  delete: {
    "id": "upload_form.undo",
    "defaultMessage": "Delete"
  }
});

const Upload = _ref => {
  let {
    composeId,
    id
  } = _ref;
  const intl = useIntl();
  const history = useHistory();
  const dispatch = useAppDispatch();
  const media = useCompose(composeId).media_attachments.find(item => item.get('id') === id);
  const descriptionLimit = useAppSelector(state => state.instance.get('description_limit'));
  const [hovered, setHovered] = useState(false);
  const [focused, setFocused] = useState(false);
  const [dirtyDescription, setDirtyDescription] = useState(null);

  const handleKeyDown = e => {
    if (e.keyCode === 13 && (e.ctrlKey || e.metaKey)) {
      handleSubmit();
    }
  };

  const handleSubmit = () => {
    handleInputBlur();
    dispatch(submitCompose(composeId, history));
  };

  const handleUndoClick = e => {
    e.stopPropagation();
    dispatch(undoUploadCompose(composeId, media.id));
  };

  const handleInputChange = e => {
    setDirtyDescription(e.target.value);
  };

  const handleMouseEnter = () => {
    setHovered(true);
  };

  const handleMouseLeave = () => {
    setHovered(false);
  };

  const handleInputFocus = () => {
    setFocused(true);
  };

  const handleClick = () => {
    setFocused(true);
  };

  const handleInputBlur = () => {
    setFocused(false);
    setDirtyDescription(null);

    if (dirtyDescription !== null) {
      dispatch(changeUploadCompose(composeId, media.id, {
        description: dirtyDescription
      }));
    }
  };

  const handleOpenModal = () => {
    dispatch(openModal('MEDIA', {
      media: ImmutableList.of(media),
      index: 0
    }));
  };

  const active = hovered || focused;
  const description = dirtyDescription || dirtyDescription !== '' && media.description || '';
  const focusX = media.meta.getIn(['focus', 'x']);
  const focusY = media.meta.getIn(['focus', 'y']);
  const x = focusX ? (focusX / 2 + .5) * 100 : undefined;
  const y = focusY ? (focusY / -2 + .5) * 100 : undefined;
  const mediaType = media.type;
  const mimeType = media.pleroma.get('mime_type');
  const uploadIcon = mediaType === 'unknown' && /*#__PURE__*/React.createElement(Icon, {
    className: "h-16 w-16 mx-auto my-12 text-gray-800 dark:text-gray-200",
    src: MIMETYPE_ICONS[mimeType || ''] || defaultIcon,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 140,
      columnNumber: 5
    }
  });
  return /*#__PURE__*/React.createElement("div", {
    className: "compose-form__upload",
    tabIndex: 0,
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave,
    onClick: handleClick,
    role: "button",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 147,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(Blurhash, {
    hash: media.blurhash,
    className: "media-gallery__preview",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 148,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement(Motion, {
    defaultStyle: {
      scale: 0.8
    },
    style: {
      scale: spring(1, {
        stiffness: 180,
        damping: 12
      })
    },
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 149,
      columnNumber: 7
    }
  }, _ref2 => {
    let {
      scale
    } = _ref2;
    return /*#__PURE__*/React.createElement("div", {
      className: classNames('compose-form__upload-thumbnail', "".concat(mediaType)),
      style: {
        transform: "scale(".concat(scale, ")"),
        backgroundImage: mediaType === 'image' ? "url(".concat(media.preview_url, ")") : undefined,
        backgroundPosition: typeof x === 'number' && typeof y === 'number' ? "".concat(x, "% ").concat(y, "%") : undefined
      },
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 151,
        columnNumber: 11
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: classNames('compose-form__upload__actions', {
        active
      }),
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 158,
        columnNumber: 13
      }
    }, /*#__PURE__*/React.createElement(IconButton, {
      onClick: handleUndoClick,
      src: require('@tabler/icons/x.svg'),
      text: /*#__PURE__*/React.createElement(FormattedMessage, {
        id: "upload_form.undo",
        defaultMessage: "Delete",
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 162,
          columnNumber: 23
        }
      }),
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 159,
        columnNumber: 15
      }
    }), mediaType !== 'unknown' && Boolean(media.url) && /*#__PURE__*/React.createElement(IconButton, {
      onClick: handleOpenModal,
      src: require('@tabler/icons/zoom-in.svg'),
      text: /*#__PURE__*/React.createElement(FormattedMessage, {
        id: "upload_form.preview",
        defaultMessage: "Preview",
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 170,
          columnNumber: 25
        }
      }),
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 167,
        columnNumber: 17
      }
    })), /*#__PURE__*/React.createElement("div", {
      className: classNames('compose-form__upload-description', {
        active
      }),
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 175,
        columnNumber: 13
      }
    }, /*#__PURE__*/React.createElement("label", {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 176,
        columnNumber: 15
      }
    }, /*#__PURE__*/React.createElement("span", {
      style: {
        display: 'none'
      },
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 177,
        columnNumber: 17
      }
    }, intl.formatMessage(messages.description)), /*#__PURE__*/React.createElement("textarea", {
      placeholder: intl.formatMessage(messages.description),
      value: description,
      maxLength: descriptionLimit,
      onFocus: handleInputFocus,
      onChange: handleInputChange,
      onBlur: handleInputBlur,
      onKeyDown: handleKeyDown,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 179,
        columnNumber: 17
      }
    }))), /*#__PURE__*/React.createElement("div", {
      className: "compose-form__upload-preview",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 191,
        columnNumber: 13
      }
    }, mediaType === 'video' && /*#__PURE__*/React.createElement("video", {
      autoPlay: true,
      playsInline: true,
      muted: true,
      loop: true,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 193,
        columnNumber: 17
      }
    }, /*#__PURE__*/React.createElement("source", {
      src: media.preview_url,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 194,
        columnNumber: 19
      }
    })), uploadIcon));
  }));
};

export default Upload;